var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpinner),expression:"showSpinner"}],staticClass:"ajax-processing-spinner hide-spinner",class:{'show-spinner': _vm.showSpinner}},[_c('i',{staticClass:"fa fa-spinner"}),_c('p',[_vm._v("Processing")])])
}
var staticRenderFns = []

export { render, staticRenderFns }